import { createContext, useContext } from 'react'

/**
 * What every row, card, drawer and the bulk bar need, passed once instead of
 * drilled: `now`, the open order, busy drivers, and the actions —
 * openOrder(id), assign(views, rider), requestFirstDelivery(views),
 * setStatus(views, status), requestCancel(views), copy(text, what).
 * Hover lives outside this so hovering a row doesn't re-render the table.
 */
export const DispatchUiContext = createContext(null)

export function useDispatchUi() {
  const ctx = useContext(DispatchUiContext)
  if (!ctx) throw new Error('useDispatchUi must be used inside DispatchUiContext')
  return ctx
}
